(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralContactDeleteController',CrmReferralContactDeleteController);

    CrmReferralContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmReferralContact'];

    function CrmReferralContactDeleteController($uibModalInstance, entity, CrmReferralContact) {
        var vm = this;

        vm.crmReferralContact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmReferralContact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
